import { DialogRef } from '@angular/cdk/dialog';
import { Component } from '@angular/core';
import {MatProgressBarModule} from '@angular/material/progress-bar';

@Component({
    selector: 'photo-uploading-dialog',
    templateUrl: './photo-uploading-dialog.html',
    styleUrls: ['./photo-uploading-dialog.scss'],
    standalone: true,
    imports: [MatProgressBarModule]
})

export class PhotoUploadingDialog {
    constructor(
        public dialogRef: DialogRef
    ) { 
        const waitTime = 2000;
        setTimeout(() => {
            this.carouselStep += 1;
        }, waitTime * 1);
        setTimeout(() => {
            this.carouselStep += 1;
        }, waitTime * 2);
        setTimeout(() => {
            this.carouselStep += 1;
        }, waitTime * 3);
    }

    public loadingCarousel = [
        { text: "Bidwell got the photo!", srcPath: '/assets/images/bidwell-loading-camera.png'},
        { text: "Bidwell's measuring twice...", srcPath: '/assets/images/bidwell-loading-measure.png'},
        { text: "Bidwell's cutting once...", srcPath: '/assets/images/bidwell-loading-phone.png'},
        { text: "Bidwell's heading to the cloud!", srcPath: '/assets/images/bidwell-loading-balloons.png'},
    ]

    public carouselStep: number = 0;

    closeDialog(): void {
        this.dialogRef.close();
    }
}